<template>
  <div class="content-management">
    <v-card>
      <v-card-title>
        内容列表
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="createContent">
          <v-icon left>mdi-plus</v-icon>
          添加内容
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="contents"
        :search="search"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="搜索"
            class="mx-4"
            prepend-icon="mdi-magnify"
          ></v-text-field>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="getStatusColor(item.status)"
            dark
          >
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editContent(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteContent(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ContentManagement',
  data () {
    return {
      search: '',
      loading: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: '标题', value: 'title' },
        { text: '类型', value: 'type' },
        { text: '作者', value: 'author' },
        { text: '状态', value: 'status' },
        { text: '发布日期', value: 'publishDate' },
        { text: '操作', value: 'actions', sortable: false }
      ],
      contents: [
        {
          id: 1,
          title: '系统使用说明',
          type: '文档',
          author: 'admin',
          status: '已发布',
          publishDate: '2023-01-15'
        },
        {
          id: 2,
          title: '新功能介绍',
          type: '公告',
          author: 'admin',
          status: '草稿',
          publishDate: '-'
        }
      ]
    }
  },
  methods: {
    getStatusColor (status) {
      if (status === '已发布') return 'green';
      if (status === '草稿') return 'orange';
      return 'grey';
    },
    createContent () {
      // 实现创建内容的逻辑
      console.log('Create new content');
    },
    editContent (content) {
      // 实现编辑内容的逻辑
      console.log('Edit content:', content);
    },
    deleteContent (content) {
      // 实现删除内容的逻辑
      console.log('Delete content:', content);
    }
  }
}
</script>

<style scoped>
.content-management {
  padding: 5px;
}
</style>
